<template>
  <div style="width:100%; margin-left:-10px">
    <div v-if="type == 'comment'">
      <div :class="[client_comment == null || client_comment == '' ? 'data-table-list-comment nocomment' : 'data-table-list-comment']" @click="activeComment(client_comment)" v-if="!input_show">
        <pre v-html="$options.filters.activeURL(client_comment)" class="data-table-list-comment-pre" style="margin:0"></pre>
      </div>
      <div style="display:flex; align-items:center" v-if="input_show">
        <textarea
          v-model="value"
          class="comment-textarea"
          :rows="textarea_rows"
          :id="id"
          @keydown.enter.ctrl.exact="addCommentList()"
          @keydown.enter.meta.exact="addCommentList()"
          @change="comment_on ? '' : addCommentList()"
          @blur="comment_on ? '' : addCommentList()"
        ></textarea>
        <!-- <i class="el-icon-circle-close pointer" style="margin-left:5px; font-size:14px; color:#aaa" @click="input_show = false"></i> -->
      </div>
    </div>
    <div v-if="type == 'num'">
      <div :class="[num == null || num == '' ? 'data-table-list-comment nocomment' : 'data-table-list-comment']" @click="activeComment(num)" v-if="!input_show">
        {{ num == null || num == "" ? "数値を入力" : num }}
      </div>
      <div style="display:flex; align-items:center" v-if="input_show">
        <el-input v-model="value" :id="id + 'num'" @keypress.enter.native="addNum()" @change="comment_on ? '' : addNum()" @blur="comment_on ? '' : addNum()"></el-input>
        <i class="el-icon-circle-close pointer" style="margin-left:5px; font-size:14px; color:#aaa" @click="closeNumComment()"></i>
      </div>
    </div>
    <div v-if="type == 'personalized_name'">
      <div
        :class="[personalized_name == null || personalized_name == '' ? 'data-table-list-comment nocomment' : 'data-table-list-comment']"
        @click="activeComment(personalized_name)"
        v-if="!input_show"
      >
        {{ personalized_name == null || personalized_name == "" ? "宛名を入力" : personalized_name }}
      </div>
      <div style="display:flex; align-items:center" v-if="input_show">
        <el-input
          v-model="value"
          :id="id + 'personalized_name'"
          @keypress.enter.native="addPersonalized()"
          @change="comment_on ? '' : addPersonalized()"
          @blur="comment_on ? '' : addPersonalized()"
        ></el-input>
        <!-- <i class="el-icon-circle-close pointer" style="margin-left:5px; font-size:14px; color:#aaa" @click="input_show = false"></i> -->
      </div>
    </div>
    <div v-if="type == 'personalized_price'">
      <div
        :class="[personalized_price == null || personalized_price == '' ? 'data-table-list-comment nocomment' : 'data-table-list-comment']"
        @click="activeComment(personalized_price)"
        v-if="!input_show"
      >
        {{ personalized_price == null || personalized_price == "" ? "報酬金額を入力" : personalized_price | addComma }}
      </div>
      <div style="display:flex; align-items:center" v-if="input_show">
        <el-input
          v-model="value"
          :id="id + 'personalized_price'"
          @keypress.enter.native="addPersonalized()"
          @change="comment_on ? '' : addPersonalized()"
          @blur="comment_on ? '' : addPersonalized()"
        ></el-input>
        <!-- <i class="el-icon-circle-close pointer" style="margin-left:5px; font-size:14px; color:#aaa" @click="input_show = false"></i> -->
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const addCommentAPI = root + "/api/list/add_comment_list";
const addNumAPI = root + "/api/list/add_num";
const addPersonalizedAPI = root + "/api/list/add_personalized";

export default {
  name: "comment",
  props: ["type", "list_id", "sns_type", "client_comment", "num", "personalized_name", "personalized_price", "id", "index"],
  data() {
    return {
      input_show: false,
      comment_on: false,
      comment_before: "",
      value: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.list.edit;
    },
    textarea_rows() {
      if (this.value) {
        var num = this.value.match(/\r\n|\n/g);
        return num > 6 ? 7 : num > 3 ? num : 3;
      } else {
        return 3;
      }
    },
  },
  methods: {
    activeComment(comment) {
      if (this.permission) {
        if (this.type == "comment") {
          var target = this.id;
        } else if (this.type == "num") {
          target = this.id + "num";
        } else if (this.type == "personalized_name") {
          target = this.id + "personalized_name";
        } else if (this.type == "personalized_price") {
          target = this.id + "personalized_price";
        }
        this.input_show = true;
        this.comment_before = comment;
        this.value = comment;
        setTimeout(() => {
          document.getElementById(target).focus();
        }, 50);
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    addCommentList() {
      if (this.permission) {
        this.comment_on = true;
        this.input_show = false;
        if (this.comment_before != this.value) {
          this.$emit("syncComment", this.index, this.value, this.type, this.list_id);
          var params = new URLSearchParams();
          params.append("list_id", this.list_id);
          params.append("influencer", this.id);
          params.append("sns_type", this.sns_type);
          params.append("comment", this.value);
          params.append("token", this.token);
          this.axios.post(addCommentAPI, params).then(() => {
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: "コメントを更新しました",
            });
          });
        }
        setTimeout(() => {
          this.comment_on = false;
        }, 300);
      }
    },
    addNum() {
      if (this.permission) {
        this.comment_on = true;
        if (isNaN(this.value)) {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "数値を入力してください",
          });
        } else {
          this.input_show = false;
          if (this.comment_before != this.value) {
            this.$emit("syncComment", this.index, this.value, this.type);
            var params = new URLSearchParams();
            params.append("list_id", this.list_id);
            params.append("influencer", this.id);
            params.append("sns_type", this.sns_type);
            params.append("num", this.value);
            params.append("token", this.token);
            this.axios.post(addNumAPI, params).then(() => {
              this.$message({
                type: "success",
                offset: 7,
                showClose: true,
                message: "数値を更新しました",
              });
            });
          }
          setTimeout(() => {
            this.comment_on = false;
          }, 300);
        }
      }
    },
    closeNumComment() {
      if (isNaN(this.value)) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "数値を入力してください",
        });
      } else {
        this.input_show = false;
      }
    },
    addPersonalized() {
      if (this.permission) {
        this.comment_on = true;
        this.input_show = false;
        if (this.type == "personalized_name") {
          var value = this.value;
          var label = "DM用宛名";
        } else if (this.type == "personalized_price") {
          value = String(this.value);
          label = "DM用報酬金額";
        }
        if (this.type == "personalized_price" && !value.match(/^[0-9]+$/) && value != "") {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "DM用報酬金額は半角数字で入力してください",
          });
          this.personalized_price = this.comment_before;
        } else if (this.comment_before != value) {
          this.$emit("syncComment", this.index, value, this.type);
          var params = new URLSearchParams();
          params.append("influencer", this.id);
          params.append("sns_type", this.sns_type);
          params.append("type", this.type);
          params.append("value", value);
          params.append("token", this.token);
          this.axios.post(addPersonalizedAPI, params).then(() => {
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: label + "を更新しました",
            });
          });
        }
        setTimeout(() => {
          this.comment_on = false;
        }, 300);
      }
    },
  },
  filters: {
    addComma(val) {
      // 数値の場合はカンマ処理が出来ない為文字列に変換する
      val = String(val);
      if (val.match(/^[0-9]+$/)) {
        return Math.floor(val).toLocaleString();
      } else {
        return val;
      }
    },
    activeURL(value) {
      const url_regexp = /https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+/g;
      if (value == null || value == ''){
        return "コメントを入力できます"
      } else {
        return value.replace(url_regexp, (url) => '<a class="router-link" href="' + url + '" target="_blank">' + url + "</a>");
      }
    },
  },
};
</script>

<style></style>
